import React, { useState } from 'react';
import { Button, Tooltip } from '@heroui/react';
import { Rss } from 'lucide-react';
import SubscribeDialog from '../calendar-month/components/SubscribeDialog.js';

/**
 * SubscribeButton — "Subscribe to my schedule" as an icon, shared by all V2
 * calendar views (USER: the nav-bar text button ate too much space).
 *
 * Sits directly AFTER the What's New bell and mirrors its geometry (44px
 * icon-only, light variant) so the title row reads as one icon cluster.
 *
 * Owns its dialog: `SubscribeDialog` needs nothing from the host page — it
 * dispatches `refreshCalendarFeedStatus` after a subscribe/rotate, which is a
 * no-op in stores that don't mount the month bootstrap reducer (week/day) and
 * updates the status live where they do (month).
 */
function SubscribeButton() {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<Tooltip content="Subscribe to my schedule" placement="bottom">
				<Button
					isIconOnly
					variant="light"
					aria-label="Subscribe to my schedule"
					// A visible gray chip at rest (USER), washing to RSS's own orange on
					// hover, glyph tinting with it. Arbitrary hex: nothing legacy to fight.
					className="min-w-11 w-11 h-11 bg-default-100 text-default-600 data-[hover=true]:bg-[#F26522]/15 data-[hover=true]:text-[#F26522]"
					onPress={() => setIsOpen(true)}
				>
					<Rss className="w-5 h-5" />
				</Button>
			</Tooltip>
			<SubscribeDialog isOpen={isOpen} onClose={() => setIsOpen(false)} />
		</>
	);
}

export default SubscribeButton;
